<template>
  <div>
    <h2>Create new reference code</h2>
    <p>
      Create a new reference code for monthly plans
    </p>
    <form @submit.prevent="submit">
      <label for="name" class="form-input">
        <span>Reference code (must be unique)</span>
        <input type="text" id="name" v-model="code">
      </label>

      <label for="monthly" class="form-input">
        <span>Discount value (This can be entered as a percentage or value. For example 50% or -2 for half price and deduct £2 respectively)</span>
        <input type="text" id="monthly" v-model="value">
      </label>

      <label for="date" class="form-input">
        <span>Expiry date in the format yyyy-mm-dd if no picker available (Leave blank for unlimited)</span>
        <input id="date" type="date" v-model="expiry">
      </label>

      <label for="email" class="form-input">
        <span>Referral Email Address (Leave blank for none)</span>
        <input type="email" id="email" v-model="email">
      </label>


      <label for="limit" class="form-input">
        <span>How many times can this reference be used? (Enter -1 for unlimited uses)</span>
        <input id="limit" type="number" v-model="limit">
      </label>

      <h2>Which plans should this reference code apply to?</h2>
      <label :for="plan.plan_slug" class="form-checkbox" v-for="plan in plans" :key="plan.plan_slug">
        <input :id="plan.plan_slug" type="checkbox" :value="plan.plan_slug" v-model="plan_list">
        <span>{{ plan.plan_name }} £{{ parseFloat(plan.monthly_cost).toFixed(2) }} (Guarantee: <span
            v-if="plan.guarantee_type == 0">Yes</span><span v-else-if="plan.guarantee_type == 1">No</span><span
            v-else-if="plan.guarantee_type == 2">Not Sure</span>)</span>
      </label>
      <div class="select-buttons">
        <button @click.prevent="selectAll">Select all</button>
        <button @click.prevent="plan_list = []">Select None</button>
      </div>


      <button @click.prevent="submit" class="submit-button">Create new code</button>
      <p class="error" v-if="error" v-html="error"></p>
    </form>
  </div>
</template>

<script>
export default {
  name: "DiscountCreator",
  props: {
    base: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      code: '',
      value: '',
      expiry: '',
      email: '',
      limit: -1,
      plan_list: [],
      plans: [],
      error: null,
    }
  },
  mounted() {
    this.getPlans();
  },
  methods: {
    submit() {
      this.error = null;
      if(!this.plan_list.length){
        this.error = "Please select at least one plan";
      }
      if (this.limit < -1 || this.limit === 0){
        this.error = "Please enter a valid limit";
      }
      if (!this.error){
        let data = {
          code: this.code,
          value: this.value,
          limit: this.limit,
          expiry_date: this.expiry,
          plans: this.plan_list.join(','),
          email: this.email,
        };
        this.$axios.post(`${this.base}/api/discounts/create.php`, this.$makeForm(data))
            .then((response) => {
              if (response.data === "saved") {
                this.$emit('save');
              } else {
                this.error = response.data;
              }
            });
      }

    },
    getPlans() {
      this.$axios.post(`${this.base}/api/plans/get.php`)
          .then((response) => {
            this.plans = response.data;
          });
    },
    selectAll(){
      this.plan_list = [];
      for (let i = 0; i < this.plans.length; i++){
        this.plan_list.push(this.plans[i].plan_slug);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
form {
  width: 50%;
}

.form-input {
  width: 100%;
  margin: 1rem 0;
  display: block;

  span, input[type=text], input[type=date], input[type=email] {
    width: 100%;
    display: block;
  }

  span {
    margin-bottom: 0.5rem;
  }

  &.half {
    width: 40%;
    margin-right: 5%;
    display: inline-block;
  }
}

.form-checkbox {
  margin: 1rem 1rem 1rem 0;
  display: inline-flex;

  span, input {
    align-self: center;
  }

  span {
    margin-left: 0.4rem;
  }
}

.select-buttons {
  display: block;

  button {
    margin: 1rem 0;
    background-color: gray;
    color: #FFF;
    border-radius: 5px;
    padding: 0.4rem;
    border: none;
    outline: none;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      background-color: #004885;
      transition: 0.2s;
    }
  }
}

.submit-button {
  display: block;
  margin: 1rem 0;
  background-color: #005EAE;
  color: #FFF;
  border-radius: 5px;
  padding: 0.5rem;
  border: none;
  outline: none;
  cursor: pointer;
  transition: 0.2s;

  &:hover {
    background-color: #004885;
    transition: 0.2s;
  }
}

.error {
  color: red;
  margin: 1rem 0;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/DiscountCreator.vue